import { setFilter } from "QuotePage/Actions";
import { getCarriersInRegion, getFilterConfig } from "QuotePage/Selectors";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { getPlans } from "Common/PlanLoader/Selectors";

import FilterBarDumb from "./mobileFilterBar/MobileFilterBarDumb";

import type { Dispatch } from "redux";

function mapStateToProps(state) {
  return {
    allPlans: getPlans(state),
    filterConfig: getFilterConfig(state),
    companyProfile: state.companyProfile,
    carriersInRegion: getCarriersInRegion(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onChangeFilter: (field, rawValue) => {
      const filterValues = rawValue[Object.keys(rawValue)[0]];
      if (filterValues) {
        AnalyticsTracking.trackEvent("quote_page_filter", {
          filter_category: field,
          [field]: JSON.stringify(filterValues),
        });
      }
      dispatch(setFilter(field, rawValue));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterBarDumb);
